export default "__VITE_ASSET__D6tJ83LE__"